import { Box, CircularProgress, Stack, Typography } from "@mui/joy";
import { ModalBackdrop } from "@mui/joy/Modal/Modal";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { addUsers, sendMessage } from "../config/services";

export const UploadId = () => {
  const { encodedimageurl, userid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    var decodeImage = atob(encodedimageurl);
    console.log(decodeImage);
    console.log(userid);

    addUsers(userid, {
      activated: true,
      kyc_verified: true,
      image_url: decodeImage,
      // imageid: downloadURL,
    })
      .then(() => {
        sendMessage(
          `KYC request from user`,
          "KYC Request",
          "cryptovaultwallet@gmail.com",
          `User`
        )
          .then(() => {
            navigate("/");
          })
          .catch((err) => {
            console.log(err);
            navigate("/");
          });
      })
      .catch((err) => console.log(err));
  });

  return (
    <ModalBackdrop
      sx={{
        flexDirection: "column",
        backgroundColor: (theme) => theme.palette.background.paper,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Box
        mt={1}
        display={"flex"}
        justifyContent={"center"}
        position={"relative"}
        top={"40%"}
      >
        <Stack spacing={1} alignItems={"center "}>
          <CircularProgress color="primary" />
          <Typography level="body-lg">Uploading ID photo</Typography>
        </Stack>
      </Box>
    </ModalBackdrop>
  );
};
